import React from "react";
import RulesPage from "../../components/rules/RulesPage";

export default function RuleBuilderPage() {
  return <RulesPage />;
}
